import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { Link } from 'react-router-dom';

import css from './HowToTestYourBoyfriendPage.module.css';
import { useIntl } from 'react-intl';

import profileIcon from './profileIcon.png'; // Make sure to add this image

const updatedDate = "03/01/2025";

const HowToTestYourBoyfriendPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const intl = useIntl();

  return (
    <StaticPage
      title="How to Test Your Boyfriend (Without Hurting Your Relationship)"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Article',
        description: 'Learn how to test your boyfriend\'s loyalty in a healthy way that strengthens your relationship.',
        name: 'How to Test Your Boyfriend',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            How to Test Your Boyfriend (Without Hurting Your Relationship)
          </h1>

          <div className={css.topInfoBar}>
            <div className={css.rowC}>
              <img src={profileIcon} alt="Profile Icon" className={css.profileIcon} />
              <div>
                <div className={css.topInfoLine}>
                  <span className={css.approval}>Clinically Approved By Shannon Bala</span>
                  <span className={css.author}>By Sarah Johnson, Author</span>
                </div>
                <div className={css.bottomInfoLine}>
                  <span className={css.reads}>15.2k Reads</span>
                  <span className={css.updatedDate}>Updated: {updatedDate}</span>
                </div>
              </div>
            </div>
          </div>

          <div className={css.contentWrapper}>
            <div className={css.contentMain}>
              <h2 className={css.pageContentsTitle}>Contents</h2>

              <ul className={css.contentsList}>
                <li><a href="#whyTest">Why People Feel the Need to Test Their Boyfriends</a></li>
                <li><a href="#canITest">Can I Test My Boyfriend Without Him Knowing?</a></li>
                <li><a href="#whatIf">What If My Boyfriend Fails the Test?</a></li>
                <li><a href="#conclusion">Conclusion</a></li>
              </ul>

              <div className={css.ParagraphBlock}>
                <p className={css.Paragraph}>
                  It's natural to want reassurance in a relationship. Maybe you've heard too many stories of heartbreak, or perhaps you've had past experiences that left you questioning trust. Take Sarah, for example—she had been with her boyfriend for nearly a year when doubts started creeping in. He was sweet, attentive, and said all the right things, but she couldn't shake the crippling feeling of uncertainty.
                </p>

                <h2 className={css.SectionTitle} id="whyTest">Why People Feel the Need to Test Their Boyfriends</h2>
                
                <h3 className={css.subtitle2}>Emotional Distress</h3>
                <p className={css.Paragraph}>Past heartbreak often leaves scars that make it difficult to trust again. If you've been cheated on or hurt in previous relationships, it's natural to want reassurance.</p>

                <h3 className={css.subtitle2}>Desire for Reassurance</h3>
                <p className={css.Paragraph}>Even in the best of relationships, doubts always seem to find one way or the other to creep in. Probably, your boyfriend acts a little off, or you're just looking for confirmation he is as committed as you are. Testing him is an easy way to get answers.</p>

                <h3 className={css.subtitle2}>Playful Curiosity</h3>
                <p className={css.Paragraph}>Not every test is due to a potentially cheating spouse, and many times, people do it simply because it is fun. It is pretty easy to be seduced by the idea of setting up some kind of scenario just to see how he reacts after all the "loyalty tests" that have gone viral on social media.</p>

                <h2 className={css.SectionTitle} id="canITest">Can I Test My Boyfriend Without Him Knowing?</h2>
                <p className={css.Paragraph}>Yes, every one of our loyalty tests are conducted with privacy as our number one priority. Our site offers dedicateed loyalty testers that will help you gain the insights you need without him ever finding out.</p>

                <h2 className={css.SectionTitle} id="whatIf">What If My Boyfriend Fails the Test?</h2>
                <p className={css.Paragraph}>If he fails it is most likely that the relatinship was not a good one to begin with. As your partner he should really be focused on making one woman happy and intrigued and thats you. If breaking up isn't an option for whatever reason, use it as one of those perfect discussion topics. Is it revealing a deeper issue? Is this something that can be overcome through communication? If yes, then the course of action is a quiet, open discussion. However, in case patterns of dishonesty or disrespect emerge, then that's the time to reevaluate the relationship.</p>

                <h2 className={css.SectionTitle} id="conclusion">Conclusion</h2>
                <p className={css.Paragraph}>If you ever need to test your boyfriend, that should not be done with a view to play tricks on him or prove any point. On the contrary, it must become a means toward finding the truth about his character, understanding your relationship, or building trust.</p>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HowToTestYourBoyfriendPage;